<template>
    <v-data-table
        :headers="headers"
        :items="entities"
        class="elevation-1"
        hide-default-footer
        disable-pagination
    >
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>{{ $t('src\\views\\bookingsettings\\list.6580') }}</v-toolbar-title>
                <v-spacer />
                <v-btn v-if="user.adminAccess && user.adminAccess.booking_settings >= ACCESS.WRITE" color="primary" @click="create">
                    <v-icon>mdi-plus</v-icon>{{ $t('src\\views\\bookingsettings\\list.7165') }}</v-btn>
            </v-toolbar>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
            {{ item.createdAt | moment('DD.MM.YYYY HH:mm') }}
        </template>
        <template v-slot:[`item.directionType`]="{ item }">
            {{ $t(DIRECTION_TYPE_TITLE[item.directionType]) }}
        </template>
        <template v-slot:[`item.trip`]="{ item }">
            {{ item.trip ? item.trip.name : $t('src\\views\\bookingsettings\\list.tourName') }}
        </template>
        <template v-slot:[`item.edit`]="{ item }">
            <v-icon color="primary" @click="edit(item._id)">mdi-pencil</v-icon>
        </template>
    </v-data-table>
</template>

<script>
    import store from '@/store';
    import { mapState } from 'vuex';
    import { DIRECTION_TYPE_TITLE } from '../../vars';
    import { ACCESS } from '@/vars';

    export default {
        name: 'BookingSettingList',
        components: {
        },
        data: () => ({
            ACCESS,
            DIRECTION_TYPE_TITLE,
            headers: [],
        }),
        computed: {
            ...mapState('auth', ['user']),
            ...mapState('bookingSettings', ['entities']),
        },
        async mounted() {
            await store.dispatch('auth/fetch');
            await store.dispatch('bookingSettings/fetch', {});
            this.headers = [
                { text: this.$t('src\\views\\bookingsettings\\list.createdAt'), value: 'createdAt' },
                { text: this.$t('src\\views\\bookingsettings\\list.trip'), value: 'trip' },
                { text: this.$t('src\\views\\bookingsettings\\list.directionType'), value: 'directionType' },
            ]
            if(this.user && this.user.adminAccess && this.user.adminAccess.booking_settings >= ACCESS.WRITE) {
                this.headers.push({ text: this.$t('src\\views\\bookingsettings\\list.edit'), align: 'right', value: 'edit' })
            }
        },
        methods: {
            async create() {
                await this.$router.push({ name: 'booking-settings-create' });
            },
            async edit(id) {
                await this.$router.push({ name: 'booking-settings-edit', params: { id } });
            }
        }
    }
</script>
